/* eslint jsx-a11y/aria-role:0 */
import React, { Component } from 'react';
import './style.css';

/*
  props:
    max
    count
    onChange(count)
*/
class QuantityPicker extends Component {
  handleAddition = () => {
    if (this.props.count < this.props.max)
      this.props.onChange(this.props.count + 1);
  }
  handleSubstraction = () => {
    if (this.props.count > 1) {
      this.props.onChange(this.props.count - 1);
    }
  }
  isNext = () => {
    return this.props.count < this.props.max;
  }
  isPrev = () => {
    return this.props.count > 1;
  }
  render() {    
    return (
      <div className="quantity-picker">
        <div className="operator-wrapper-kiosk">
          <div style={{backgroundColor:`#`+this.props.secondaryColor,  opacity: (this.isPrev() ? '1' : '0.4')}} onClick={this.handleSubstraction} className="operator-kiosk" role="decreaseAmt" >&minus;</div>
          <div className="amt">
          <div className="qnt-kiosk">{this.props.count}</div></div><div style={{backgroundColor:`#`+this.props.secondaryColor,  opacity: (this.isNext() ? '1' : '0.4')}} onClick={this.handleAddition} className="operator-kiosk" role="increaseAmt">+</div>
        </div>
      </div>
    );
  }
}

export default QuantityPicker;



// WEBPACK FOOTER //
// ./src/components/KioskQuantityPicker/KioskQuantityPicker.jsx